import React from "react";
import RadioButton from "../radio-button";
import TextInput from "../textinput";
import { useAppSelector } from "../../../store/hooks/StoreHooks";

interface RadioInputProps {
  label: string;
  name: string;
  radioName: string;
  checked?: boolean;
  inputPlaceholder?: string;
  inputType?: string;
  onRadioChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  inputValue: string | number;
  onInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  unit?: string;
  required?: boolean;
  disabled?: boolean;
  error?: string;
}

const RadioInput: React.FC<RadioInputProps> = ({
  label,
  name,
  radioName,
  checked = false,
  inputPlaceholder = "Enter here",
  inputType = "text",
  onRadioChange,
  inputValue,
  onInputChange,
  onBlur,
  unit,
  required,
  disabled,
  error,
}) => {

  const { customerEnabled, customerCreated } = useAppSelector((state) => state.auth);
  const { projectReadOnly } = useAppSelector((state) => state.projectHeader);

  return (
    <>
      {
        <div className="flex flex-col justify-start items-start gap-2 w-full">
          <RadioButton
            label={label}
            name={radioName}
            checked={checked}
            required={required}
            onChange={onRadioChange}
          />
          <TextInput
            label=""
            placeholder={inputPlaceholder}
            type={inputType}
            value={inputValue}
            onChange={onInputChange}
            onBlur={onBlur}
            name={name}
            unit={unit}
            disabled={disabled || (customerEnabled && !customerCreated) || projectReadOnly}
            error={error}
          />
        </div>
      }
    </>

  );
};

export default RadioInput;
